import { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import OrderSummary from "@/components/OrderSummary";
import api, { apiErr } from "@/lib/api";

export default function QuotationView() {
  const { token } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/public/quotation/${token}`);
      setOrder(data);
    } catch (e) {
      setError(apiErr(e, "Quotation not found"));
    }
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const onAccept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/public/quotation/${token}/accept`);
      setOrder(data);
      toast.success("Quotation accepted");
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  const onPay = async (amount) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/public/quotation/${token}/pay`, { amount });
      setOrder(data);
      toast.success("Payment confirmed");
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <header className="bg-white border-b border-[#E5E7EB]">
        <div className="mx-auto max-w-2xl px-4 sm:px-6 h-16 flex items-center justify-between">
          <Logo />
          <Link to="/login" className="text-sm font-semibold text-[#0A4F35] hover:underline">Customer Login</Link>
        </div>
      </header>
      <div className="mx-auto max-w-2xl px-4 sm:px-6 py-8">
        {error ? (
          <div className="rounded-lg border border-red-200 bg-red-50 p-8 text-center text-red-700">{error}</div>
        ) : !order ? (
          <div className="text-center text-slate-500 py-20">Loading quotation…</div>
        ) : (
          <OrderSummary order={order} onAccept={onAccept} onPay={onPay} busy={busy} />
        )}
      </div>
    </div>
  );
}
